import { createSlice } from '@reduxjs/toolkit';

const ttlockSlice = createSlice({
	name: 'ttlock',
	initialState: { loading: false, error: null },
	reducers: {
		triggerSync: (state) => {
			state.loading = true;
		},
		triggerSyncSuccess: (state) => {
			state.loading = false;
		},
		triggerSyncError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		}
	}
});

export const ttlockActions = ttlockSlice.actions;
export default ttlockSlice.reducer;
